import { createFileRoute } from '@tanstack/react-router';
import { Conversations } from '@/components/Conversations';

export const Route = createFileRoute('/_auth/conversations/')({
  component: ConversationsRoute,
});

function ConversationsRoute() {
  return <Conversations />;
}
